"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ValidationError = require("./ValidationError");

var _ValidationError2 = _interopRequireDefault(_ValidationError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Select = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Select, _Component);

  function Select() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Select);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Select.__proto__ || (0, _getPrototypeOf2.default)(Select)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (value) {
      _this.props.fieldProps.onChange(value);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Select, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          fieldProps = _props.fieldProps,
          disableLabel = _props.disableLabel,
          small = _props.small;

      var hasError = fieldProps.touched && fieldProps.error;
      var formGroupClasses = "form-group select";

      if (hasError) {
        formGroupClasses += " has-error";
      }

      if (disableLabel) {
        formGroupClasses += " select-no-label";
      }

      if (small) {
        formGroupClasses += " form-group-small";
      }

      return _react2.default.createElement(
        "div",
        { className: formGroupClasses },
        _react2.default.createElement(
          "label",
          { className: "placeholder" },
          "\xA0"
        ),
        _react2.default.createElement(
          "select",
          { onChange: this.handleChange, value: this.props.fieldProps.value },
          _react2.default.createElement(
            "option",
            { value: "", key: "placeholder-0" },
            this.props.placeholder
          ),
          this.renderOptions()
        ),
        _react2.default.createElement(_ValidationError2.default, { fieldProps: this.props.fieldProps })
      );
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      return this.props.options.map(function (option, index) {
        return _react2.default.createElement(
          "option",
          { key: index, value: option.id },
          option.name
        );
      });
    }
  }]);
  return Select;
}(_react.Component), _class.propTypes = {
  options: _react.PropTypes.array.isRequired,
  fieldProps: _react.PropTypes.object.isRequired,
  placeholder: _react.PropTypes.string.isRequired,
  disableLabel: _react.PropTypes.bool,
  small: _react.PropTypes.bool
}, _temp2);
exports.default = Select;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/form/Select.js
 ** module id = 90
 ** module chunks = 0
 **/